<template>
  <ac-modal :title="''" ref="modalRef" :size-class="'modal-lg'">
    <template slot="header">
      <div class="row" v-if="widgetReady">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12">
              <h4 class="text-center">
                {{ model.fullName }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="widgetReady">
      <div class="row">
        <div class="col-lg-6">
          <h5>Member Address</h5>
          <address>
            <span v-if="!model.addressId">
              <strong>Address not set</strong>
            </span>
            <span v-else>
              <span>{{ model.address }}</span>,&nbsp;
              <br/>
              <span>{{ model.region }}</span>&nbsp;
              <span>{{ model.zipCode }}</span>
            </span>
            <br/>
            <span>{{ model.phoneNumber | phoneNumber }}</span>
            <br/>
            <span>{{ model.emailAddress }}</span>
          </address>
        </div>
        <div class="col-lg-6">
          <h5>Current Coverage Type (Effective - {{ model.effectiveDate | shortDate }}) :
          </h5>
          <div>
            <span>{{ model.coverageTypeName }}</span>
            <span v-if="model.numberOfChildren>0">
              [Number of dependents: {{ model.numberOfChildren }} ]
            </span>
            <div v-if="actionNeededCurrentCoverage">
              <div class="alert alert-warning">
                <span v-html="actionNeededCurrentCoverage"></span>
              </div>
            </div>
          </div>
          <div v-if="model.coverageTypeNameFuture">
            <h5>Future Coverage Type (Effective - {{ model.effectiveDateFuture | shortDate }} ) : </h5>
            <div>
              <span>{{ model.coverageTypeNameFuture }}</span>
              <span data-bind="if:numberOfChildrenFuture">
                [Number of children: {{ model.numberOfChildrenFuture }} ]
              </span>
              <div v-if="actionNeededFutureCoverage">
                <div class="alert alert-warning">
                  <span v-html="actionNeededFutureCoverage"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="model.members.length>0">
        <div class="col-md-12">
          <h4>Members Registered</h4>
          <div style="overflow:auto">
            <table class="mdl-data-table table table-responsive dataTable no-footer dtr-inline">
              <thead>
              <tr>
                <th>Name</th>
                <th>Relationship To Primary</th>
                <th width="20%">Benefit Start Date</th>
                <th width="20%">Term</th>
                <th width="20%">Plan Selection Date</th>
                <th width="10%">Plan Selected</th>
                <th width="15%">Plan Category</th>
              </tr>
              </thead>
              <tbody v-for="member in model.members">
              <tr class="even">
                <td>{{ member.fullName }}</td>
                <td>{{ member.relationshipToPrimaryName }}</td>
                <td>{{ member.effectiveDate | shortDate }}</td>
                <td>{{ member.effEndDate | shortDate }}</td>
                <td>{{ member.selectionDate | shortDate }}</td>
                <td>{{ member.dpcSelected }}</td>
                <td>{{ member.planCategory }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-12">
          <h4>No members have completed their profile</h4>
        </div>
      </div>
    </template>
  </ac-modal>
</template>

<script>
import {api} from "../../../global/framework/api.js";
import {common} from "../../../global/common.js";

export default {
  name: "view-employee-modal",
  data() {
    return {
      widgetReady: false,
      model: {},
      profileImage: "",
      actionNeededCurrentCoverage: "",
      actionNeededFutureCoverage: ""
    };
  },
  methods: {
    async showModal(data) {
      //console.log("data:", data);
      let vm = await api.getDataWithTwoIds("Company", data.companyId, "ViewEmployee", data.consumerId);
      this.profileImage = common.generateImageLink(vm.profileImageId, common.IMAGE_SIZE.MEDIUM);
      await this.prepareData(vm);
      this.mapData('model', vm);
      this.widgetReady = true;
      this.$refs.modalRef.open();
    },
    async prepareData(employeeData) {
      employeeData.members = [];
      if (!employeeData.mainAccountHasBeenSetup) {
        let mainNotice = "Primary employee has not completed his/her profile <br>";
        this.actionNeededCurrentCoverage += mainNotice;
        this.actionNeededFutureCoverage += mainNotice;
      } else {
        //member row per category
        let planSelections = employeeData.planSelections && employeeData.planSelections.length > 0
            ? employeeData.planSelections
            : [{selectionDate: employeeData.selectionDate, planCategory: employeeData.planCategory}];
        planSelections.forEach(selection => {
          employeeData.members.push({
            fullName: employeeData.fullName,
            relationshipToPrimaryName: 'Self',
            effectiveDate: employeeData.originalEffDate,
            effEndDate: employeeData.effEndDate,
            dpcSelected: employeeData.dpcSelected,
            selectionDate: selection.selectionDate,
            planCategory: selection.planCategory
          });
        });
      }
      employeeData.members = employeeData.members.concat(employeeData.dependents);
      this.actionNeededCurrentCoverage += this.getActionNeeded(employeeData.dependents, employeeData.effectiveDate, {
        coverageTypeId: employeeData.coverageLevelId,
        numberOfChildren: employeeData.numberOfChildren
      });
      this.actionNeededFutureCoverage += this.getActionNeeded(employeeData.dependents, employeeData.effectiveDateFuture, {
        coverageTypeId: employeeData.coverageLevelIdFuture,
        numberOfChildren: employeeData.numberOfChildrenFuture
      });
    },
    getActionNeeded(registeredDependents, dateRef, coverageRef) {
      let actionNeeded = "";
      let coverageTypeId = coverageRef.coverageTypeId;
      //It is possible to not have a future cov change, meaning there is no reference date
      if (!dateRef) {
        return "";
      }
      let coverageDate = common.getJsDateFromLongFormat(dateRef);
      let dependentsForThisCoverage = this.getRegisteredDependents(registeredDependents, coverageDate);
      //Check spouse requirement
      if (coverageTypeId == 2 || coverageTypeId == 4) {//EE+SPOUSE OR EE+SPOUSE+CHILDREN
        if (dependentsForThisCoverage.filter(
            function (item) {
              return item.relationshipToPrimary == 2;
            }).length === 0) {
          actionNeeded += "Spouse has not been added yet <br>";
        }
      }
      //Now its time to check children
      if (coverageTypeId == 3 || coverageTypeId == 4) {
        let currentChildren = dependentsForThisCoverage.filter(function (dep) {
          return dep.relationshipToPrimary == 3;
        });
        let childrenDifference = coverageRef.numberOfChildren - currentChildren.length;
        if (childrenDifference > 0) {
          actionNeeded += childrenDifference + " child" + (childrenDifference > 1 ? "ren" : "") +
              (childrenDifference > 1 ? " have" : " has") + " not been added yet. ";
        }
      }
      return actionNeeded;
    },
    getRegisteredDependents(registeredDependents, coverageDate) {
      let dependentsForThisCoverage = [];
      for (let i = 0; i < registeredDependents.length; i++) {
        let currentDep = registeredDependents[i];
        //Dependent was added the day the coverage changed or after
        if (common.getJsDateFromLongFormat(currentDep.effStartDate) >= coverageDate ||
            !currentDep.effEndDate ||
            (currentDep.effEndDate && common.getJsDateFromLongFormat(currentDep.effEndDate) > coverageDate)
        ) {
          dependentsForThisCoverage.push(currentDep);
        }
      }
      return dependentsForThisCoverage;
    }
  }
}
</script>

<style scoped>

</style>